import AdUnit from "../../core/AdUnit";

import { YANDEX_ADS_SDK_URL, AdvIDPrefix, AdUnitStatus, event } from "../../utils/const";
import { getRandomString, createVideoSlot } from '../../utils/utils';
import LibLoader from "../../utils/LibLoader";

class YandexInstream extends AdUnit {
  constructor(cfg) {
    super(cfg);

    this._init();
  }

  _init() {
    if (!(window.ya && window.ya.videoAd && window.ya.videoAd.loadModule)) {
      // return injectScript(YANDEX_ADS_SDK_URL, () => this._init());
      return LibLoader.load(YANDEX_ADS_SDK_URL,
        () => this._init(),
        () => {
          this.logger.log('[YandexInstream] error during load library');
          this.localEmitter.emit(event.Ad.AdError, { code: 9 });
        }
      );
    }

    this.logger.log(`[YandexInstream - ${this.config.playerConfig.zone} / ${this.config.params.tid}] _init() called`, this.config);

    this.advID = AdvIDPrefix.YANDEX_INSTREAM + getRandomString();
    this.videoSlot = createVideoSlot();
    this.slot.id = getRandomString();
    this.slot.appendChild(this.videoSlot);

    this.adPlaybackController = null;

    this.status = AdUnitStatus.LOADED;
  }

  start() {
    this.logger.log(`[YandexInstream - ${this.config.playerConfig.zone} / ${this.config.params.tid}] start() called`, this);
    const { partnerid, category, impid } = JSON.parse(this.config.template);
    
    this._startTimestamp = Date.now();

    // resetActiveSlots(this.config.playerNode, true);
    this.slot.classList.add('active');

    ya.videoAd
      .loadModule("AdLoader")
      .then(function (module) {
        return module.AdLoader.create({
          partnerId: partnerid,
          category,
          impId: impid,
          secureMode: "Unsafe",
          targetRef: window.location.href
        });
      })
      .then(function (adLoader) {
        return adLoader.loadAd();
      })
      .then((adViewer) => {
        adViewer.preload({
          videoSlot: this.videoSlot,
          vpaidTimeout: 60000,
          bufferFullTimeout: 60000,
          videoTimeout: 60000,
        });

        this.localEmitter.emit(event.Ad.AdLoaded);

        return new Promise((resolve) => {
          resolve(adViewer);
        });
      })
      .then((adViewer) => {
        this.adPlaybackController = adViewer.createPlaybackController(
          this.videoSlot,
          this.slot, // config.yandexInframe ? iframe.contentDocument.body : slot
          {
            skipDelay: 10,
            vpaidTimeout: 60000,
            bufferFullTimeout: 60000,
            videoTimeout: 60000,
          }
        );

        this.adPlaybackController.subscribe("AdStarted", () => {
          this.localEmitter.emit(event.Ad.AdVideoStart);
          // started = true;
          // emitter.emit(event.Ad.AdVideoStart, { advID });
          // emitter.emit(event.Player.YandexInstreamStarted);

          this.slot.style.zIndex = '20';
        });

        this.adPlaybackController.subscribe("AdPodError", () => {
          this.localEmitter.emit(event.Ad.AdError, { code: 5 });
          // emitter.emit(event.Ad.AdError, { advID, params, error });
        });

        this.adPlaybackController.subscribe("AdClickThru", () => {
          this.localEmitter.emit(event.Ad.AdClickThru);
          // emitter.emit(event.Ad.AdClickThru, { advID });
        });

        this.adPlaybackController.subscribe("AdPodImpression", () => {
          this.localEmitter.emit(event.Ad.AdImpression);
          // emitter.emit(event.Ad.AdImpression, { advID });
          // unit.isImpressionEmitted = true;
        });

        this.adPlaybackController.subscribe("AdPodVideoFirstQuartile", () => {
            this.localEmitter.emit(event.Ad.AdVideoFirstQuartile);
            // emitter.emit(event.Ad.AdVideoFirstQuartile, { advID });
          }
        );

        this.adPlaybackController.subscribe("AdPodVideoMidpoint", () => {
          this.localEmitter.emit(event.Ad.AdVideoMidpoint);
          // emitter.emit(event.Ad.AdVideoMidpoint, { advID });
        });

        this.adPlaybackController.subscribe("AdPodVideoThirdQuartile", () => {
            this.localEmitter.emit(event.Ad.AdVideoThirdQuartile);
            // emitter.emit(event.Ad.AdVideoThirdQuartile, { advID });
          }
        );

        this.adPlaybackController.subscribe("AdSkippableStateChange", () => {
            // this.localEmitter.emit(event.Ad.AdVideoComplete);
            // this.localEmitter.emit(event.Ad.AdSkippableStateChange);
            // emitter.emit(event.Ad.AdSkippableStateChange, { advID });
          }
        );

        this.adPlaybackController.subscribe(
          "AllAdPodVideoComplete",
          () => {
            this.localEmitter.emit(event.Ad.AdVideoComplete);
            // if (started) {
            //   emitter.emit(event.Ad.AdVideoComplete, { advID });
            //   emitter.emit(event.Player.YandexAdFinished);

            //   complete = true;
            // }

            // emitter.emit(event.Player.AdUnitFinished);
          }
        );
        this.adPlaybackController.subscribe("AdStopped", () => {
          this.localEmitter.emit(event.Ad.AdStopped);
          // if (!complete && started) {
          //   emitter.emit(event.Ad.AdStopped, { advID });
          //   emitter.emit(event.Player.YandexAdFinished);
          // }
        });
        this.adPlaybackController.subscribe("AdPodSkipped", () => {
          this.localEmitter.emit(event.Ad.AdVideoComplete);
          // this.localEmitter.emit(event.Ad.AdSkipped);
          // emitter.emit(event.Ad.AdSkipped, { advID });

          // complete = true;
        });

        this.adPlaybackController.subscribe("AdPlayingStateChange", (evt) => {
          // if (evt.playingState === 'pause') {
          //   this.localEmitter.emit(event.Ad.AdPaused);
          // } else {
          //   this.localEmitter.emit(event.Ad.AdPlaying);
          // }
        });

        this.emitter.emit(event.Player.PlayerVisibilityChangeRequest, true);
        this.adPlaybackController.setAdVolume(0);
        this.adPlaybackController.playAd();
      })
      .catch((error) => {
        this.localEmitter.emit(event.Ad.AdError, { code: 0 });
      });
  }
  resume() { if (this.adPlaybackController) return this.adPlaybackController.resumeAd(); }
  pause() { if (this.adPlaybackController) return this.adPlaybackController.pauseAd(); }
}

export default YandexInstream;
